import {HttpClient} from '@angular/common/http';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatTabGroup} from '@angular/material/tabs';

@Component({
  selector: 'aw-test-output-info-dialog',
  templateUrl: './test-output-info-dialog.component.html',
  styleUrls: ['./test-output-info-dialog.component.scss']
})
export class TestOutputInfoDialogComponent implements OnInit {
 @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;
  input: any = null;
  rowFromOutputList: any = null ;
  dataOutput: any = null;
  viewMode: 'tree' | 'table' = 'table';
  reportData: any = null;

  constructor(
    public dialogRef: MatDialogRef<TestOutputInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
  this.rowFromOutputList = this.data.dataTable;

  const allFiles = [...this.data.dataOutput];

  // Report = metadata.json
  // metadata.json detection
  const metadataFile = allFiles.find((item: any) =>
    'title' in item && 'description' in item && !('exitCode' in item)
  );


  // input.json detection
  const inputFile = allFiles.find((item: any) =>
  'iface' in item
  );
  if (inputFile) {
    this.input = inputFile;
  }
  const semaphoreFile = allFiles.find((item: any) =>
    'result' in item && !('description' in item) && !('exitCode' in item)
  );
  if (semaphoreFile && metadataFile) {
   this.reportData = {
      title: metadataFile.title,
      description: metadataFile.description,
      result: semaphoreFile.result
    };
  }


  // Outputs = everything else (skip metadata.json, input.json, fullreport.json, random junk)
  this.dataOutput = allFiles.filter((item: any) => {
  if (!item.name) return false;

  // Skip known special files
  if (['metadata.json', 'input.json', 'fullreport.json'].includes(item.name)) {
    return false;
  }

  // Skip random UUID JSONs (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx.json)
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.json$/i.test(item.name)) {
    return false;
  }

  // Keep only real output files
  return true;
});

  //console.log("OUTPUT FILES THAT WILL RENDER:", this.dataOutput);
}

  isEmpty(obj: any): boolean {
    if (Array.isArray(obj)) {
      return obj.length === 0;
    } else if (obj && typeof obj === 'object') {
      return Object.keys(obj).length === 0;
    }
    return false;
  }
  getResultColor(result: string): string {
  const colorMap: { [key: string]: string } = {
    'red': '#FF0000',
    'green': '#00FF00',
    'blue': '#0000FF',
    'yellow': '#FFFF00',
    'orange': '#FFA500',
    'purple': '#800080',
    'black': '#000000',
    'gray': '#808080'
  };

  return colorMap[result] || '#808080'; // Default to gray if color not found

}
openTab(tab: 'input' | 'lastOutput') {
    if (tab === 'input') {
      // Input tab is usually the last tab, adjust index if necessary
      this.tabGroup.selectedIndex = this.tabGroup._tabs.length - 1;
    } else if (tab === 'lastOutput') {
      // Last output tab is just before Input tab
      this.tabGroup.selectedIndex = this.tabGroup._tabs.length - 2;
    }
  }
}
